import styled from "styled-components";
import { SyncFilled } from "@assets";

export const Container = styled.div`
padding: 5px;
padding-left: 22px;
border-radius: 30px;
background-color: #C21C05;
cursor: pointer;
box-shadow: 0px 4px 19px 0px rgba(0, 0, 0, 0.10), 0px 2px 6px 0px rgba(0, 0, 0, 0.20);

display: flex;
gap: 8px;

@media screen and (max-width: 375px) {
    padding-left: 12px;
}

@media screen and (max-width: 320px) {
    gap: 4px;
}
`;

export const TextWrapper = styled.div`
flex: 1;
`;

export const Title = styled.div`
font-size: 10px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #F5D016;
`;

export const Text = styled.div`
display: inline-flex;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: #FFF;

@media screen and (max-width: 375px) {
    font-size: 10px;
}
`;

export const ActionButton = styled.div`
display: flex;
gap: 4px;
justify-content: center;
align-items: center;
padding: 4px 13px;
border-radius: 27px;
background-color: #fffc;
cursor: pointer;

@media screen and (max-width: 375px) {
    padding: 4px;
    gap: 2px;
}
`;

export const ActionText = styled.div`
font-size: 10px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: #101415;
`;

export const RefreshIcon = styled(SyncFilled)`
margin-bottom: -2px;
color: #F5D016;
`;